import React, { memo } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { themeGet } from 'styled-system'
import NavLink from '../NavLink'
import NavDropdown from '../NavDropdown'
import { headerNavigationShape } from '../../utils/shapes'

const StyledNavLink = styled(NavLink)`
  width: 100%;
  padding: ${themeGet('space.3')}px;
`
StyledNavLink.displayName = 'StyledNavLink'

function SmallNavigation ({
  color,
  iconColor,
  dropdownColor,
  navigation,
  target
}) {
  return (
    navigation &&
    navigation.length > 0 &&
    navigation.map(link => {
      return link.links ? (
        <NavDropdown
          key={link.label}
          {...link}
          color={color}
          iconColor={iconColor}
          backgroundColor={dropdownColor}
          target={target}
        />
      ) : (
        <StyledNavLink
          key={link.label}
          {...link}
          color={color}
          iconColor={iconColor}
          target={target}
        />
      )
    })
  )
}

SmallNavigation.displayName = 'SmallNavigation'

SmallNavigation.propTypes = {
  color: PropTypes.string,
  iconColor: PropTypes.string,
  dropdownColor: PropTypes.string,
  navigation: PropTypes.arrayOf(headerNavigationShape),
  target: PropTypes.string
}

export default memo(SmallNavigation)
